// columnsCount = number of columns without id and name
export function getListColumnWidth(columnsCount: number, noNameColumn?: 'noNameColumn') {
  return {
    nameWidth: '30%',
    columnWidth: `${(noNameColumn ? 100 : 70) / columnsCount}%`,
  }
}
